<template>
    <div class="landing">
        <!-- <h1 v-if="isVersion2">Speel Lotto&lsquo;s Jingle Balls - de&nbsp;trouwe&nbsp;spelers&nbsp;editie. <br class="hide-for-small"/>En&nbsp;maak kans op mooie prijzen</h1> -->
        <h1>Speel Lotto&lsquo;s Ballenbak en <br class="hide-for-xlarge"/>maak kans op &euro;&nbsp;4.500!</h1>

        <div class="prizes" v-if="isVersion2">
            <div>
                <img src="/static/img/prizes/tv.jpg"/>
                <p>3x LG TV</p>
            </div>
            <div>
                <img src="/static/img/prizes/ipads.jpg"/>
                <p>4x Apple iPad</p>
            </div>
            <div>
                <img src="/static/img/prizes/sonosplay.jpg"/>
                <p>1x Sonos Play 1</p>
            </div>
            <div>
                <img src="/static/img/prizes/sonosbeam.jpg"/>
                <p>1x Sonos Beam</p>
            </div>
            <div>
                <img src="/static/img/prizes/rituals.jpg"/>
                <p>5x Rituals Pakket</p>
            </div>
        </div>

        <v-landingvisual ref="landingVisual" :size="size"></v-landingvisual>

        <button class="black" @click="toGame">Speel nu</button>
        <button class="clear" @click="toExplain">Uitleg</button>
    </div>
</template>

<style lang="scss" scoped>
</style>

<script>
    import { TimelineMax } from '@/vendor';
    import { tracking } from '@/app/mixins';
    import LandingVisual from '@/app/components/LandingVisual';

    export default {
        components: {
            'v-landingvisual': LandingVisual
        },

        mixins: [ tracking ],

        data()
        {
            return {
                size: Math.min( window.innerWidth / 2.5, 250 )
            };
        },

        computed: {
            isVersion2()
            {
                return this.$store.getters.isVersion2;
            }
        },

        mounted()
        {
            this.preloadImages();

            window.addEventListener( 'resize', this.onResize.bind( this ) );
        },

        methods: {
            toExplain( e )
            {
                this.trackEvent( 'Klik op button - Uitleg', 'Link tracking', window.location.origin + '/spel/uitleg' );
                this.$router.push( 'spel/uitleg' );
            },

            toGame()
            {
                this.trackEvent( 'Klik op button - Speel nu', 'Link tracking', window.location.origin + '/spel' );
                this.$router.push( 'spel' );
            },

            onResize()
            {
                this.size = Math.min( window.innerWidth / 2.5, 250 );
            },

            preloadImages()
            {
                let images = [
                    '/static/img/explain/1.jpg',
                    '/static/img/explain/2.jpg',
                    '/static/img/explain/3.jpg',
                    '/static/img/explain/4.jpg',
                    '/static/img/explain/5.jpg',
                    '/static/img/game/box.jpg',
                    '/static/img/game/lint.png',
                    '/static/img/game/elem1.png',
                    '/static/img/game/elem2.png',
                    '/static/img/game/elem3.png',
                    '/static/img/game/elem4.png',
                    '/static/img/game/elem5.png',
                    '/static/img/game/elem-outline.png',
                    '/static/img/game/takke-bg.png'
                ];

                for( let i = 0; i < images.length; i++ )
                {
                    let img = new Image();
                    img.src = images[ i ];
                }
            },

            getAnimateIn()
            {
                let tl = new TimelineMax();

                tl.from( '.landing h1', 0.6, { autoAlpha: 0 }, 0.6 );
                if( this.isVersion2 )
                {
                    tl.from( '.landing .prizes', 1.5, { autoAlpha: 0 }, 0.6 );
                }

                tl.from( this.$refs.landingVisual.$el, 1, { autoAlpha: 0 }, 0.8 );
                tl.from( '.landing button', 0.5, { autoAlpha: 0 }, 1.3 );

                tl.add( this.$refs.landingVisual.getAnim().play(), 1.5 );
                return tl;
            },

            getAnimateOut()
            {
                let tl = new TimelineMax();
                return tl;
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/pages/Landing.vue